import React from 'react'
import InstitutionNodes from '../InstitutionNodes'

const MyInstitutionNodes = () => {
  // El backend ignora el ID provisto y usa el asociado al token del admin_institucion.
  return <InstitutionNodes institution={{ idInstitucion: 'propia' }} />
}

export default MyInstitutionNodes
